export default "__VITE_ASSET__YrBR6CjZ__"